export class EventManager {
    constructor() {
        this.listeners = new Map();
        this.on = (event, listener) => {
            var _a, _b;
            const newListeners = (_b = (_a = this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.add(listener)) !== null && _b !== void 0 ? _b : new Set([listener]);
            this.listeners.set(event, newListeners);
        };
        this.off = (event, listener) => {
            var _a;
            (_a = this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.delete(listener);
        };
        this.emit = (event, ...data) => {
            const listeners = this.listeners.get(event);
            if (listeners && listeners.size > 0) {
                listeners.forEach((callback) => {
                    callback(...data);
                });
            }
        };
        this.removeAllListeners = () => {
            this.listeners = new Map();
        };
    }
}
//# sourceMappingURL=EventManager.js.map